import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';

const ErrorPage = ({ statusCode }) => {
  const { t } = useTranslation();
  return (
    <div className="error">
      <Link className="error-logo" href="/">
        bina.az
      </Link>
      <p className="error-status">{statusCode}</p>
      <p className="error-text">{t('pages.error.error_text')}</p>
      <Link className="error-link" href="/">
        {t('pages.error.link_to_main')}
      </Link>
    </div>
  );
};

ErrorPage.propTypes = {
  statusCode: PropTypes.number
};

export default ErrorPage;
